import { Typography } from '@/src/shared/components/Typography';
import styles from './LandingStats.module.scss';
import { LANDING_STATS } from './stats';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';
import { Section } from '../Section';

export const LandingStats = () => {
  const isMobile = useIsMobile();

  return (
    <Section className={styles.container}>
      <Typography
        variant="heading"
        size={isMobile ? 'h5' : 'h4'}
        className={styles.title}
      >
        Why Top Professionals Choose VuSocial?
      </Typography>
      <div className={styles.reportCards}>
        {LANDING_STATS.map(({ value, title }) => {
          return (
            <div className={styles.reportCard} key={title}>
              <Typography variant="display" tag="h5">
                {value}
              </Typography>
              <Typography variant="display" tag="h4">
                {title}
              </Typography>
            </div>
          );
        })}
      </div>
    </Section>
  );
};
